import React from "react";

const Copyright = () => {
  return (
    <div className="copyright">
      <p>© {new Date().getFullYear()} Daniel Haddon Photography</p>
    </div>
  );
};

export default Copyright;
